import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import { ReactSVG } from 'react-svg';
import dynamicfunction from '../../utils/dynamicfunction';
import ViewItems from '../ViewItems';
import { fontSizes } from '../../constants/constants';
import Button from './Button';
import ViewReverse from '../ViewReverse';
import { cn } from '../../utils/utils';
import Text from './Text';

const ConfirmModal = ({
  isOpen,
  onClose,
  icon,
  title,
  titleWeight,
  descOne,
  descTwo,
  leftBtn,
  rightBtn,
  rightBtnClasses,
  leftBtnClasses,
  onLeftPress,
  onRightPress,
  loading,
  descOneClasses,
  descTwoClasses,
  onDescPress,
}) => {
  const { TextWeight } = dynamicfunction();

  return (
    <Dialog open={isOpen} onClose={loading ? null : onClose}>
      <DialogContent className='w-full md:min-w-[370px] md:max-w-[400px]'>
        <ViewItems className={'items-center mt-3'}>
          {
            icon && <ReactSVG src={icon} />
          }

          <Text text={title} weight={titleWeight ?? TextWeight.playfairSemiBold} className={cn('mb-3 text-dark-blue', icon && 'mt-8')} size={fontSizes.h22} />

          <Text text={descOne} className={cn('text-center', descOneClasses)} />
          <Text text={descTwo} className={cn('text-center', descTwoClasses)} onClick={onDescPress ?? null} />
        </ViewItems>

        <ViewReverse className={'gap-2 mt-5'}>
          {leftBtn && (
            <Button
              text={leftBtn}
              className={cn('w-full bg-white border border-grey !text-dark-grey', leftBtnClasses)}
              onClick={onLeftPress}
              isDisabled={loading}
            />
          )}
          {rightBtn && (
            <Button
              text={rightBtn}
              className={cn('w-full', rightBtnClasses)}
              onClick={onRightPress}
              isDisabled={loading}
              loading={loading}
              loaderClasses={'border-white !border-2'}
            />
          )}
        </ViewReverse>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmModal;
